var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.36 6H7v6h7.24l.4 2H18V8h-5.24l-.4-2Z",
    fill: "#FFA51E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6Zm3.6 8h-3.36l-.4-2H7V6h5.36l.4 2H18v6Z",
    fill: "#FFA51E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowFlagIcon);
export default __webpack_public_path__ + "static/media/yellowFlagIcon.e270d26dbbe9ea23081a0ccdd5c538e9.svg";
export { ForwardRef as ReactComponent };